import { useParams } from 'react-router-dom';

import { Avatar, Space, Typography } from 'antd';

import { getCdnUrl } from '@/helpers';
import { coursesApi } from '@/services/course';
import styled, { css, StyledProp } from '@/styled';

const Author = (props: StyledProp) => {
  const { hash } = useParams<{ hash: string }>();
  const { data: course } = coursesApi.endpoints.getCourse.useQueryState(hash, { skip: !hash });
  return (
    <Space {...props} size={24} direction='vertical'>
      <Avatar src={getCdnUrl(course?.author?.avatar, '')} size={82} />
      <Typography.Title level={4}>{course?.author?.name}</Typography.Title>
      <Typography.Paragraph>{course?.author?.description}</Typography.Paragraph>
      {/* <Space size={16}>
        <Button icon={<Instagram size={24} />} ghost />
        <Button icon={<Twitter size={24} />} ghost />
        <Button icon={<Linkedin size={24} />} ghost />
      </Space> */}
    </Space>
  );
};

export default styled(Author)(
  ({ theme }) => css`
    width: calc(100% - 48px);
    margin: 0 auto;
    border: 1px solid ${theme.variables.courseAuthorBorder};
    border-radius: ${theme.borderRadius}px;
    padding: ${theme.space.pxToRem(24)};
    align-items: center;
    transition: ${theme.motionDurationMid};

    svg,
    div.ant-typography {
      color: ${theme.colorTextTertiary};
    }

    button {
      border: none;
    }

    h4.ant-typography {
      margin: 0;
    }
  `
);
